<template>
  <div></div>
</template>
  <script>
import { appPostMessage } from '@/utils/communication'
import { setSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
      show: false,
      configData: '',
    }
  },
  mounted() {
    let that = this
    window['getPreamble'] = (url) => {
      that.getpreamble(url) // 这个也就是我定义的方法
    }
    setTimeout((res) => {
      const msg = { code: 19, data: '' }
      appPostMessage(msg)
    }, 500)
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const user_entity = {
        // access_token: '00000192850660278d9e1ae8123407681', //10002345  244317550059
        // access_token: '000001928506698bfc5ece7c664209973', //176 10001251  077095580944
        access_token: '000001947416698c02a02fcf622149997', //10002371
        lang: 'ja-jp',
        app_id: '7b7e0d9f32d7dff8098fdf069574e3c1',
        kid: 123,
      }
      if (window.location.host.indexOf('localhost') > -1) {
        this.getpreamble(user_entity)
      }
    },
    getpreamble(data) {
      console.log('获取数据', data)
      setSessionStorage('preambleInfo', JSON.stringify(data))
      const lang = data.lang
      this.$i18n.locale = data.lang
      this.getLang(lang)
      const processENV = process.env.NODE_ENV
      if (
        processENV.indexOf('development') > -1 ||
        processENV.indexOf('staging') > -1
      ) {
        this.configData = {
          platform: 'pc',
          app_id: '7b7e0d9f32d7dff8098fdf069574e3c1',
          // app_id: 'de8262d0998df22715fbec24a2d76afe',
          // app_id: 'c96526e0fae0b978453ce0274c87a16d',
          kid: data.kid,
          lang: data.lang,
          client_app_id: data.app_id,
          sdk_code: 3,
        }
      } else {
        this.configData = {
          platform: 'web',
          app_id: 'c96526e0fae0b978453ce0274c87a16d',
          //   app_id: '7b7e0d9f32d7dff8098fdf069574e3c1',
          kid: data.kid,
          lang: data.lang,
          client_app_id: data.app_id,
          sdk_code: 3,
        }
      }
      setSessionStorage('message', JSON.stringify(this.configData))

      this.$router.push({ path: '/preamblelogin' })
    },
    async getLang(lang) {
      const obj = await require('@/assets/lang/' + lang + '.js')
      setSessionStorage('lang1', JSON.stringify(obj.title))
    },
  },
}
</script>
  
  <style scope lang="less">
// .preamble_box {
//   width: 100%;
//   padding: 30/75rem;
//   box-sizing: border-box;
//   .preamble_item {
//     font-weight: 400;
//     font-size: 22/75rem;
//     line-height: 33/75rem;
//     color: #707070;
//     position: relative;
//     padding-right: 200/75rem;
//     .btn {
//       position: absolute;
//       width: 160/75rem;
//       height: 50/75rem;
//       right: -0px;
//       top: 10/75rem;
//       text-align: center;
//       border-radius: 30/75rem;
//       border: 1px solid #ff7391;
//       line-height: 50/75rem;
//       font-size: 24/75rem;
//       color: #ff7391;
//     }
//   }
//   .line {
//     width: 100%;
//     height: 1px;
//     background: #c7c7c7;
//     // border: 1px solid #c7c7c7;
//     margin-bottom: 30/75rem;
//     margin-top: 30/75rem;
//   }
// }
</style>